export const getDepartmentDisplayName = (department) => {
  const normalized = String(department || '').trim();

  if (!normalized) {
    return '';
  }

  if (normalized === 'Roads') {
    return 'Roads and Operations';
  }

  if (normalized === 'Finance') {
    return 'Corporate Services';
  }

  return normalized;
};

export const normalizeDepartmentForBackend = (department) => {
  const normalized = String(department || '').trim();

  if (!normalized) {
    return '';
  }

  if (normalized === 'Roads and Operations') {
    return 'Roads';
  }

  if (normalized === 'Corporate Services') {
    return 'Finance';
  }

  return normalized;
};